<section class="d-flex flex-column flex-grow-1" (mouseenter)="showText.set(true)" (mouseleave)="showText.set(false)">

  <!-- Fav Icon -->
  <div class="product-card__pre-head" [ngClass]="{'card-img active-filter-blur': isOutOfStock()}">
    @if(!isSignupFlow() && hasSession() && !allVariantsOutOfStock()) {
    <div class="product-card__like-dislike">
      <!-- Like -->
      @if (isFavorite()) {
      <span (click)="outHandleFavoriteChange.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48612a">
          <path
            d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" />
        </svg>
      </span>
      } @else {
      <span (click)="outHandleFavoriteChange.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48612a">
          <path
            d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50 81q36 45.5 98 107T480-228Zm0-273Z" />
        </svg>
      </span>
      }
      <!-- Dislike -->
      @if (isDislike()) {
      <span (click)="outPrevDislikeProduct.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48612a">
          <path
            d="M240-840h400v520L360-40l-50-50q-7-7-11.5-19t-4.5-23v-14l44-174H120q-32 0-56-24t-24-56v-80q0-7 1.5-15t4.5-15l120-282q9-20 30-34t44-14Zm480 520v-520h160v520H720Z" />
        </svg>
      </span>
      } @else {
      <span (click)="outPrevDislikeProduct.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#48612a">
          <path
            d="M240-840h440v520L400-40l-50-50q-7-7-11.5-19t-4.5-23v-14l44-174H120q-32 0-56-24t-24-56v-80q0-7 2-15t4-15l120-282q9-20 30-34t44-14Zm360 80H240L120-480v80h360l-54 220 174-174v-406Zm0 406v-406 406Zm80 34v-80h120v-360H680v-80h200v520H680Z" />
        </svg>
      </span>
      }
    </div>
    }

    <!-- Tags Icons -->
    <div class="product-card__tags">
      @for (tag of productTags() || []; track $index) {
      <span>
        {{tag.name}}
      </span>
      }
    </div>
  </div>

  <!-- Card Header - Title and Subtitle -->
  <div class="product-card__head" [ngClass]="{'card-img active-filter-blur': isOutOfStock()}">
    @if(!customizeBox()) {
    <a [routerLink]="productRouterLink()">
      <h3 class="product-card__title" [ngbTooltip]="productName()">{{productName()}}</h3>
    </a>
    } @else {
    <a>
      <h3 class="product-card__title" [ngbTooltip]="productName()">{{productName()}}</h3>
    </a>
    }
    <h5 class="product-card__subtitle">{{ producerName() }}</h5>
  </div>

  <div class="product-card__img-wrap" [ngClass]="{'card-img active-filter-blur': isOutOfStock()}">
    <!-- Sale Badge -->
    @if(selectedAttributeCardConfig().hasDiscount && selectedAttributeCardConfig().isOnSale) {
    <span class="sale-badge">{{isMobile() ? 'Sale' : '% On Sale'}}</span>
    }

    @if(!isSignupFlow()) {
    <a [routerLink]="productRouterLink()">
      @defer (on viewport; prefetch on immediate) {
      <img [src]="selectedAttributeCardConfig().image || 'assets/images/product-placeholder.webp'"
        alt="Image of {{card().product?.name}}" (error)="handleImageError($event)" class="product-card__img"
        [ngClass]="{'disliked': isDislike()}">
      } @placeholder {
      <div style="height: 150px;"></div>
      }
    </a>
    } @else {
    <a>
      @defer (on viewport; prefetch on immediate) {
      <img [src]="selectedAttributeCardConfig().image || 'assets/images/product-placeholder.webp'"
        (error)="handleImageError($event)" class="product-card__img" alt="Image of {{productName()}}">
      } @placeholder {
      <div style="height: 150px;"></div>
      }
    </a>
    }

    <!-- Hovered Button over main image -->
    @if (card().product.bundle?.items?.length) {
    <div class="info-badge">
      <button type="button" class="rolling-info"
        [class.active]="showText || (selectedAttributeCardConfig().isSubscription && existsInOrder().subscription && bundleModifyType === bundleModifyTypes.outOfOrder)"
        (click)="outOpenModalWhatsInside.emit($event)">
        @if(selectedAttributeCardConfig().isSubscription && existsInOrder().subscription &&
        bundleModifyType === bundleModifyTypes.outOfOrder) {
        <i class="rolling-info-icon fas fa-check"></i>
        <span class="rolling-info__text" [class.active]="showText()">
          Subscribed
        </span>
        }
        @else {
        <i class="rolling-info-icon fas fa-info-circle"></i>
        <span class="rolling-info__text" [class.active]="showText()">
          What's inside
        </span>
        }
      </button>
    </div>
    }

    @if (!isSignupFlow()) {
    @if (!marketStatus().isOpen && !card().product.preOrder && !selectedAttributeCardConfig().isSubscription) {
    <div class="d-grid position-absolute bottom-0 pb-3 w-100">
      <div class="mb-0 w-100 alert py-2 px-3 alert-warning d-flex align-items-center animated fadeIn" role="alert">
        @if (isMobile()) {
        <div class="h8-regular text-center">
          Available <b>on {{marketStatus().openingDay | titlecase}}</b>
        </div>
        } @else {
        <div class="h7-regular" [innerHTML]="marketClosedMessage()"></div>
        }
      </div>
    </div>
    }
    }

    <!-- Purchase Limit -->
    @if (selectedAttributeCardConfig().purchaseLimit) {
    <div class="card-action-labels-bottom">
      <span class="limited-to">{{selectedAttributeCardConfig().purchaseLimit}} Max</span>
      <span class="material-symbols-outlined">production_quantity_limits</span>
    </div>
    }
  </div>

  @if (isOutOfStock() || isOutOfStockPerQuantity()) {
  <app-out-of-stock [class.oosperQuantity]="isOutOfStockPerQuantity()"
    [isOutOfStockPerQuantity]="isOutOfStockPerQuantity()" [isOutOfStock]="isOutOfStock()" [hasNotify]="hasNotify()"
    [isFromSummary]="false" (outFlipCardType)="outFlipCardType.emit({type: $event})"
    (outModalCheckAddress)="outOpenModalCheckAddress.emit()"></app-out-of-stock>
  }

  <section [class.d-none]="isOutOfStock()">
    <div class="product-card__meta">
      <div class="product-card__meta--item is-col-2">
        <div class="d-grid">
          <div class="d-flex gap-1 flex-row align-items-center">

            @if(!selectedAttributeCardConfig().isABundle && !selectedAttributeCardConfig().bundle?.items?.length &&
            selectedAttributeCardConfig().bundle?.priceRange) {
            <h5 class="product-card__price">{{ selectedAttributeCardConfig().bundle?.priceRange }}</h5>
            } @else {
            <h5 class="product-card__price">{{ selectedAttributeCardConfig().price | currency }}</h5>
            }

            @if(selectedAttributeCardConfig().hasDiscount) {
            <small class="product-card__price--line-through text-body-tertiary fw-bold text-decoration-line-through">
              {{selectedAttributeCardConfig().originalPrice | currency}}
            </small>
            }
          </div>
          @if (selectedAttributeCardConfig().display) {
          <p class="product-card__info">
            {{selectedAttributeCardConfig().display || ''}}
          </p>
          }
        </div>

        <!-- Quantity buttons -->
        @if (!purchaseLimitReached()) {
        <div class="col quantity">
          @if (wasValueHigher10()) {
          <small class="how-many-label d-none d-sm-block">How many?</small>
          }
          <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
            @if( wasValueHigher10() || newQuantity() >= 10 || (newQuantity() >= 10 &&
            wasValueHigher10()) ){
            <input type="text" matInput appNumberRestriction [minNumber]="1" [maxNumber]="totalStockAvailable()"
              (change)="outOnInputQuantityChange.emit($event)" (keyup)="outOnKeyUp.emit($event)"
              [value]="newQuantity()">
            }
            @else{
            <mat-select [value]="newQuantity()" (selectionChange)="outOnQuantityChange.emit($event)">
              @for(q of availableQuantities(); track $index){
              <mat-option [value]="q.val">{{ q.name }}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
        </div>
        } @else {
        <!-- Purchase Limit Reached Message -->
        <div class="purchase-limit-reached">
          <span class="material-symbols-outlined">production_quantity_limits</span>
          <span class="limited-to">Limit Reached</span>
        </div>
        }

      </div>

      <!-- Product Customizations  -->
      <div class="row">
        <div class="col-12 d-flex gap-1">
          @if (card().settings.showAttributes) {
          @if (productAttributes().length) {
          @for (attr of productAttributes(); track $index) {
          <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
            <mat-label class="text-capitalize">{{attr.name.toLowerCase()}}</mat-label>
            @if (card().product.variantId || attr.values.length === 1) {
            <input matInput type="text" readonly="true" [value]="selectedAttribute()?.value.name">
            } @else {
            <mat-select [value]="selectedAttribute()?.value?.id || ''"
              (selectionChange)="outOnAttributeChange.emit({id: attr.id, event: $event})">
              @for (item of attr.values; track $index) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
          }
          }
          @if (card().product.packages?.length) {
          <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
            <mat-label class="text-capitalize">Package</mat-label>
            @if (card().product.packages?.length === 1) {
            <input matInput type="text" readonly="true" [value]="selectedPackage()?.name">
            } @else {
            <mat-select [value]="selectedPackage()?.id || ''"
              (selectionChange)="outOnPackageChanged.emit($event.value)">
              @for (item of card().product.packages; track $index) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
              }
            </mat-select>
            }
          </mat-form-field>
          }
          }
        </div>
      </div>
    </div>

    <!-- Action button -->
    @if(!customizeBox()) {
    <div class="product-card__action">
      <div class="d-grid gap-2">
        @if (hasSession()) {
        @if (selectedAttributeCardConfig().isSubscription) {
        @if (card().product.bundle?.items?.length) {
        <div [class.action-col-2]="marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte">
          @if(stockSignal().size) {
          @if (marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte) {
          <button type="button" (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
            [disabled]="isDisabledActionButtons()" class="btn btn-outline-secondary d-flex gap-2 align-items-center">
            @if (isMobile()) {
            <i class="fas fa-plus"></i>
            } @else {
            {{getButtonTextBundle()}}
            }
          </button>
          }
          <button type="button" [disabled]="isDisabledSubscribeButton()"
            (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
            class="btn {{!!skippedSubscriptionLineId() ? 'btn-primary' : 'btn-secondary'}} d-flex gap-2 align-items-center">
            {{getButtonTextBundleSubscription()}}
          </button>
          } @else {
          <p class="placeholder-glow mb-0 w-100">
            <span
              class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
              style="height: 36px;"></span>
          </p>
          }
        </div>
        }
        @else {
        <div [class.action-col-2]="marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte">
          @if(stockSignal().size) {
          @if (marketStatus().isOpen && selectedAttributeCardConfig().isALaCarte) {
          <button type="button" (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
            [disabled]="isDisabledActionButtons()" class="btn btn-outline-secondary d-flex gap-2 align-items-center">
            @if (isMobile()) {
            <i class="fas fa-plus"></i>
            } @else {
            {{getButtonTextSingle()}}
            }
          </button>
          }
          <button type="button" [disabled]="isDisabledSubscribeButton()"
            (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
            class="btn {{!!skippedSubscriptionLineId() ? 'btn-primary' : 'btn-secondary'}} d-flex gap-2 align-items-center">
            {{getButtonTextSubscription()}}
          </button>
          } @else {
          <p class="placeholder-glow mb-0 w-100">
            <span
              class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
              style="height: 36px;"></span>
          </p>
          }
        </div>
        }
        }
        @else {
        @if(stockSignal().size && selectedAttributeCardConfig().isALaCarte) {
        <button type="button" (click)="outAddProductToCart.emit({isSubscription: false, event: $event})"
          [disabled]="isDisabledActionButtons() || (!card().product.preOrder && !marketStatus().isOpen)"
          class="btn btn-secondary d-flex gap-2 align-items-center"
          [class.btn-outline-secondary]="existsInOrder().common || isPreOrderedVariant()">
          {{getButtonTextSingle()}}
        </button>
        } @else {
        <p class="placeholder-glow mb-0 w-100">
          <span class="placeholder w-100 col-12 bg-secondary rounded btn btn-secondary d-flex gap-2 align-items-center"
            style="height: 36px;"></span>
        </p>
        }
        }
        }
        @else {
        <button type="button" (click)="outOpenModalCheckAddress.emit()"
          class="btn btn-secondary d-flex gap-2 align-items-center">
          Add To Delivery
        </button>
        }
      </div>
    </div>
    } @else {
    <div class="product-card__action">
      <button type="button" (click)="outFlipCardType.emit({type: cardTypes.subscribe})"
        class="btn {{ isSubscribed() ? 'btn-secondary' : 'btn-primary'}} d-flex gap-2 align-items-center">
        {{isSubscribed() ? 'Subscribed' : 'Subscribe'}}
      </button>
    </div>
    }
  </section>

</section>